import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { InboxPage } from "@/features/inbox/InboxPage";

const search = z.object({
  view: z.enum(["open", "us", "them", "snoozed", "done", "outbox", "drafts", "ai-drafts", "spam", "on-hold"]).optional(),
  box: z.enum(["shared"]).optional(),
  assignee: z.enum(["me"]).optional(),
  client: z.string().optional(),
  project: z.string().optional(),
  unread: z.boolean().optional(),
});

export const Route = createFileRoute("/_app/inbox/")({
  validateSearch: search,
  component: () => <InboxPage search={Route.useSearch()} />,
});
